import { Injectable, Pipe, PipeTransform } from '@angular/core';
import { Case } from '../../modules/cases/models/case/case.model';

@Pipe({
  name: 'caseType',
})
@Injectable({
  providedIn: 'root',
})
export class CaseTypePipe implements PipeTransform {
  /**
   * take the case orderType and retur the right orderType name as a translation key
   * @param caseToCheck from type case model
   * @returns the orderType name as a translation key
   */
  transform(caseToCheck: Case): string {
    switch (caseToCheck.orderType) {
      case 0: {
        return 'CASE_TYPE.NONE';
      }
      case 1: {
        if (caseToCheck.langSource === caseToCheck.langDest) {
          return 'CASE_TYPE.CORRECTION';
        }

        return 'CASE_TYPE.TRANSLATION';
      }
      case 2: {
        return 'CASE_TYPE.LECTORATE';
      }
      case 3: {
        return 'CASE_TYPE.CORRECTORATE';
      }
      case 4: {
        return 'CASE_TYPE.ATTESTATION';
      }
      case 5: {
        return 'CASE_TYPE.CERTIFIED_TRANSLATION';
      }
      case 6: {
        return 'CASE_TYPE.CERT_TRANS_WITHOUT_GER';
      }
      case 7: {
        return 'CASE_TYPE.PROOFREADING';
      }
      case 8: {
        return 'CASE_TYPE.MACHINE_TRANSLATION';
      }
      case 9: {
        if (caseToCheck.caseType === 10) {
          return 'CASE_TYPE.LIGHT_POSTEDITING';
        }
        return 'CASE_TYPE.POSTEDITING';
      }
      case 10: {
        return 'CASE_TYPE.LIGHT_POSTEDITING';
      }
    }
    return '';
  }
}
